export default function Modal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmButtonStyle,
  confirmDisabled = false,
  cancelDisabled = false,
  hideFooter = false,
  maxWidth = 480,
  contentStyle,
}) {
  if (!isOpen) {
    return null;
  }

  const modalStyle = maxWidth === 480
    ? undefined
    : { width: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal"
        style={modalStyle}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <h3 id="modal-title" className="modal-title">
          {title}
        </h3>

        {description ? <p className="modal-description">{description}</p> : null}

        <div className="modal-content" style={contentStyle}>{children}</div>

        {hideFooter ? null : (
          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              disabled={cancelDisabled}
              className="button"
            >
              {cancelLabel}
            </button>

            <button
              type="button"
              onClick={onConfirm}
              disabled={confirmDisabled}
              className="button btn-danger"
              style={confirmButtonStyle}
            >
              {confirmLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
